import React, { useState, useEffect, useMemo, useRef } from "react";
import Sidebar from "../sidebar/Sidebar";
import apiService from "../../utils/api";
import "./RecentsPage.css";
import downloadIcon from "../../assets/download.svg";
import editIcon from "../../assets/edit.svg";
import linktofileIcon from "../../assets/linktofile.svg";
import arrow from '../../assets/arrow.svg';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import DeleteConfirmationModal from '../modals/DeleteConfirmationModal';
import { FaSearch, FaCaretDown } from "react-icons/fa";
import Breadcrumbs from "../../components/Breadcrumbs";
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Info } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Loader from '../Loader';
import ArchiveEmailTemplate from '../../utils/ArchiveEmailTemplate';


// Helper to map status_id to status name
const mapStatusIdToName = (statusId) => {
  const statusMap = {
    1: 'Draft',
    2: 'Active',
    3: 'Trashed',
  };
  return statusMap[statusId] || 'Unknown';
};

const calculateModified = (modifiedDate) => {
  try {
    const now = new Date();
    const modDate = new Date(modifiedDate);
    if (isNaN(modDate.getTime())) {
      return 'Unknown';
    }
    const diffMs = now - modDate;
    const absDiffMs = Math.abs(diffMs);
    const diffHours = Math.floor(absDiffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(absDiffMs / (1000 * 60 * 60 * 24));
    const diffMonths = Math.floor(absDiffMs / (1000 * 60 * 60 * 24 * 30));
    const suffix = diffMs >= 0 ? "ago" : "ago";

    if (absDiffMs < 1000 * 60) return "just now";
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? "s" : ""} ${suffix}`;
    if (diffDays < 30) return `${diffDays} day${diffDays > 1 ? "s" : ""} ${suffix}`;
    return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ${suffix}`;
  } catch (error) {
    console.error("Error calculating modified time:", error);
    return 'Unknown';
  }
};

const getCleanContractId = (id) => {
  // Use a bounded, anchored, and Unicode-safe regex per Sonar secure guidelines
  const match = String(id).match(/\d{1,20}$/u);
  return match ? match[0] : id;
};
const RecentsPage = () => {
  const [days, setDays] = useState("7");
  const [showColumnOptions, setShowColumnOptions] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState({});
  const navigate = useNavigate();
  const mandatoryColumns = ['name', 'status', 'dateCreated'];
  const [sortConfig, setSortConfig] = useState({ key: 'dateCreated', direction: 'desc' });
  const [visibleColumns, setVisibleColumns] = useState(() => {
  const savedColumns = localStorage.getItem('recentsTableVisibleColumns');
  const defaultColumns = {
    name: true,
    clientName: true,
    dateCreated: true,
    status: true,
    modified: true,
    actions: true,
  };
 let cols = savedColumns ? JSON.parse(savedColumns) : defaultColumns;
  mandatoryColumns.forEach(col => {
    if (cols.hasOwnProperty(col)) cols[col] = true;
  });
  return cols;
});

const [tempVisibleColumns, setTempVisibleColumns] = useState({ ...visibleColumns });

 
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [contracts, setContracts] = useState([]);
  const [rawRecords, setRawRecords] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, success: false, message: '' });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [loadingCount, setLoadingCount] = useState(0);
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [originalHierarchy, setOriginalHierarchy] = useState([]);           
const [currentHierarchyMode, setCurrentHierarchyMode] = useState("default"); 
const [switchingHierarchy, setSwitchingHierarchy] = useState(false);    
  // Fetch userId from sessionStorage
  const getUserId = () => {
    const storedUserId = sessionStorage.getItem('user_id');
    return storedUserId || ""; // Fallback to "1" if not found
  };

  const userId = getUserId();

  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(0, prev - 1));
  const isLoading = loadingCount > 0;
useEffect(() => {
  if (showColumnOptions) {
    let temp = { ...visibleColumns };
    mandatoryColumns.forEach(col => {
      if (temp.hasOwnProperty(col)) temp[col] = true;
    });
    setTempVisibleColumns(temp);
  }
}, [showColumnOptions, visibleColumns]);

  useEffect(() => {
    localStorage.setItem('recentsTableVisibleColumns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

const addLevels = (nodes, level = 0) => {
  if (!Array.isArray(nodes)) return [];
  return nodes.map(node => {
    // clone so we don't mutate original structure unintentionally
    const newNode = { ...node, level };
    if (newNode.children && newNode.children.length > 0) {
      newNode.children = addLevels(newNode.children, level + 1);
    }
    return newNode;
  });
};
const removeDeletedNodes = (nodes) => {
  return nodes
    .map(node => {
      if (node.children?.length) {
        const filteredChildren = removeDeletedNodes(node.children);
        // keep the node only if it has remaining children
        if (filteredChildren.length > 0) {
          return { ...node, children: filteredChildren };
        }
        return null; // remove empty folder
      }
      // include only non-deleted files
      return node.data?.type === "File" && !node.data?.is_deleted ? node : null;
    })
    .filter(Boolean);
};


  useEffect(() => {
    const fetchContracts = async () => {
      startLoading();
      try {
        if (!days) {
          setSnackbar({ open: true, success: false, message: "Please select a valid number of days" });
          return;
        }
       const queryParams = `recent-contracts?user_id=${userId}&days=${days}`;
       console.log('Fetching recent contracts with URL:', queryParams);
       const response = await apiService.fetchData(queryParams);

const hierarchy = response?.contract_hierarchy || [];
setOriginalHierarchy(hierarchy);
const withLevels = addLevels(hierarchy);
const cleanedHierarchy = removeDeletedNodes(withLevels);
setRawRecords(cleanedHierarchy);

console.log("hierarchy with levels:", withLevels);

            if (hierarchy.length === 0) {
     setSnackbar({
       open: true,
       success: false,
       message: "No recent contracts found",
    });
  }
       

        
      } catch (error) {
        console.error("Error fetching contracts:", {
          message: error.message,
          stack: error.stack,
          response: error.response ? error.response.data : null,
        });
        setSnackbar({
          open: true,
          success: false,
          message: `Failed to load documents: ${error.message}`,
        });
        setContracts([]);
        setRawRecords([]);
      } finally {
        stopLoading();
      }
    };

    fetchContracts();
  }, [days, userId]);

  // 🔹 Flatten hierarchical records into a flat array for export/search
const flattenNodes = (nodeList) => {
  let flat = [];
  nodeList.forEach(node => {
    if (node.data?.type === 'File') flat.push(node.data);
    if (node.children?.length) flat = flat.concat(flattenNodes(node.children));
  });
  return flat;
};

// 🔹 Build flat list
const allFiles = flattenNodes(rawRecords);

// 🔹 Search state
const [search, setSearch] = useState("");

// 🔹 Apply search filter
const filteredFiles = allFiles.filter(file =>
  (file.name || '').toLowerCase().includes(search.toLowerCase()) ||
  (file.clientName || '').toLowerCase().includes(search.toLowerCase()) ||
  (file.status || '').toLowerCase().includes(search.toLowerCase())
);

// 🔹 Rebuild filtered tree for TreeTable view
const filterTree = (nodeList) => {
  return nodeList
    .map(node => {
      if (node.data?.type === 'File') {
        const match =
          (node.data.name || '').toLowerCase().includes(search.toLowerCase()) ||
          (node.data.clientName || '').toLowerCase().includes(search.toLowerCase()) ||
          (node.data.status || '').toLowerCase().includes(search.toLowerCase());
        return match ? node : null;
      }
      const filteredChildren = filterTree(node.children || []);
      return filteredChildren.length > 0 ? { ...node, children: filteredChildren } : null;
    })
    .filter(Boolean);
};

const filteredNodes = search.trim() ? filterTree(rawRecords) : rawRecords;

  const handleAddFavourite = async (node) => {
  const contractId = node.data?.id || node.id;
  const userId = getUserId();
  const newIsFavourite = !node.data?.is_favourite;

  // Clean the contract ID
  let rawContractId = contractId;
  if (String(rawContractId).includes("CONTRACT-")) {
    rawContractId = rawContractId.replace("CONTRACT-", "");
  }

  const payload = {
    user_id: userId,
    contract_id: rawContractId,
  };

  try {
    const response = await apiService.postData(
      `favourites?is_favourite=${newIsFavourite}`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === "error" || !response.status) {
      setSnackbar({
        open: true,
        success: false,
        message: response.message || "Failed to update favourite",
      });
    } else {
      node.data.is_favourite = newIsFavourite;
      setSnackbar({
        open: true,
        success: true,
        message: newIsFavourite
          ? "Contract added to favourites"
          : "Contract removed from favourites",
      });
    }
  } catch (error) {
    console.error("Error posting to favourites:", error);
    setSnackbar({
      open: true,
      success: false,
      message: "Error updating favourite",
    });
  }
};


const swapYearAndClient = (yearFirstNodes) => {
  const clientMap = new Map();

  yearFirstNodes.forEach((yearNode) => {
    const yearKey = yearNode.key;
    const yearName = yearNode.data.year || yearNode.data.name || "Unknown Year";

    (yearNode.children || []).forEach((clientNode) => {
      const clientName = clientNode.data.clientName || clientNode.data.name || "Unknown Client";
      const clientKey = clientNode.key.split("-")[0];

      if (!clientMap.has(clientKey)) {
        clientMap.set(clientKey, {
          key: clientKey,
          data: { type: "Folder", name: clientName, clientName },
          children: [],
        });
      }

      clientMap.get(clientKey).children.push({
        key: `${clientKey}-${yearKey}`,
        data: { type: "Folder", name: yearName },
        children: clientNode.children || [],
      });
    });
  });

  return Array.from(clientMap.values());
};

const handleSwitchHierarchy = () => {
  if (!originalHierarchy || originalHierarchy.length === 0) return;

  setSwitchingHierarchy(true);

  try {
    let processed;

    if (currentHierarchyMode === "default") {
      processed = swapYearAndClient(originalHierarchy);
      setCurrentHierarchyMode("client-first");
    } else {
      processed = originalHierarchy;
      setCurrentHierarchyMode("default");
    }

    const withLevels = addLevels(processed);
    const cleanedHierarchy = removeDeletedNodes(withLevels);
    setRawRecords(cleanedHierarchy);
  } finally {
    setSwitchingHierarchy(false);
  }
};

  const handleTrash = (contract) => {
    setContractToDelete(contract);
    setIsDeleteModalOpen(true);
  };

const confirmDelete = async (reason) => {
  if (!contractToDelete) return;
  setIsDeleting(true);
  try {
    const rawContractId = getCleanContractId(contractToDelete.data?.id || contractToDelete.id);
    const payload = { user_id: getUserId(), contract_id: rawContractId, reason };

    const response = await apiService.postData('enhanced-trash', payload);
    if (response?.status === 'success') {
      const emailData = {
        recipientName: sessionStorage.getItem('user_name') || 'User',
        contractTitle: contractToDelete.data?.name,
        contractId: rawContractId,
        previousStatus: contractToDelete.data?.status || 'Active',
        userName: sessionStorage.getItem('user_name') || 'User',
        actionDate: new Date().toISOString().split('T')[0],
        actionReason: reason,
        contractUrl: contractToDelete.data?.file_url || '#',
      };
      const html = ArchiveEmailTemplate(emailData);
      await apiService.sendEmail(
        sessionStorage.getItem('user_emailId') || '',
        'Contract Moved to Archive',
        html
      );
      setSnackbar({ open: true, success: true, message: `Contract archived successfully` });
    } else {
      throw new Error(response?.message || 'Failed to archive');
    }
  } catch (err) {
    setSnackbar({ open: true, success: false, message: `Error archiving: ${err.message}` });
  } finally {
    setIsDeleting(false);
    setIsDeleteModalOpen(false);
  }
};

const toggleColumn = (key) => {
  if (mandatoryColumns.includes(key)) return;
  setTempVisibleColumns((prev) => ({ ...prev, [key]: !prev[key] }));
};

  const applyColumnChanges = () => {
  const newVisible = { ...tempVisibleColumns };
  mandatoryColumns.forEach(col => {
    if (newVisible.hasOwnProperty(col)) newVisible[col] = true;
  });
  setVisibleColumns(newVisible);
  localStorage.setItem('recentsTableVisibleColumns', JSON.stringify(newVisible));
  setShowColumnOptions(false);
};

  const cancelColumnChanges = () => {
    setTempVisibleColumns({ ...visibleColumns });
    setShowColumnOptions(false);
  };

  const handleSelectAll = () => {
    // Select All functionality removed
  };

  const handleContractSelect = (contractId) => {
    // Contract selection functionality removed
  };

  const handleSort = (key) => {
    setSortConfig((prevConfig) => {
      if (prevConfig.key === key && prevConfig.direction === 'asc') {
        return { key, direction: 'desc' };
      }
      return { key, direction: 'asc' };
    });
  };

  const handleOpenDocument = (fileUrl) => {
    window.open(fileUrl, '_blank');
  };

  const filteredContracts = useMemo(() => {
    // No filtering needed since we removed the filter controls
    return contracts;
  }, [contracts]);

  const sortedContracts = useMemo(() => {
    let sortableContracts = [...filteredContracts];
    if (sortConfig.key) {
      sortableContracts.sort((a, b) => {
        let aValue = sortConfig.key === 'dateCreated' ? a.rawDate : a.rawModified;
        let bValue = sortConfig.key === 'dateCreated' ? b.rawDate : b.rawModified;

        if (aValue === null && bValue === null) return 0;
        if (aValue === null) return 1;
        if (bValue === null) return -1;

        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }
    console.log('Sorted contracts:', sortableContracts);
    return sortableContracts;
  }, [filteredContracts, sortConfig]);

  const itemsPerPage = rowsPerPage;
  const total = sortedContracts.length;
  const totalPages = Math.max(1, Math.ceil(total / itemsPerPage));
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, total);
  const currentContracts = useMemo(() => {
    console.log('Current contracts:', sortedContracts.slice(startIndex, endIndex));
    return sortedContracts.slice(startIndex, endIndex);
  }, [sortedContracts, startIndex, endIndex]);

 const exportTableToCSV = () => {
  // Define all possible headers and their corresponding data fields
  const columnMap = [
    { key: 'name', header: 'Contract Name', field: 'name' },
    { key: 'clientName', header: 'Client', field: 'clientName' },
    { key: 'dateCreated', header: 'Created Date', field: 'createdDate' },
    { key: 'status', header: 'Status', field: 'status' },
    { key: 'modified', header: 'Modified', field: 'modified' },
  ];

  // Filter headers based on visibleColumns
  const headers = columnMap
    .filter(col => visibleColumns[col.key])
    .map(col => col.header);

  // Filter rows based on visibleColumns
  const rows = filteredFiles.map(f =>
    columnMap
      .filter(col => visibleColumns[col.key])
      .map(col => f[col.field] || '')
  );

  if (rows.length === 0) {
    setSnackbar({ open: true, success: false, message: 'No data available to export.' });
    return;
  }

  const csv = [headers.join(','), ...rows.map(r => r.join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'recents_export.csv';
  link.click();
};
const exportTablePDF = () => {
  const doc = new jsPDF();
  // Define all possible headers and their corresponding data fields
  const columnMap = [
    { key: 'name', header: 'Contract Name', field: 'name' },
    { key: 'clientName', header: 'Client', field: 'clientName' },
    { key: 'dateCreated', header: 'Created Date', field: 'createdDate' },
    { key: 'status', header: 'Status', field: 'status' },
    { key: 'modified', header: 'Modified', field: 'modified' },
  ];

  // Filter headers based on visibleColumns
  const headers = columnMap
    .filter(col => visibleColumns[col.key])
    .map(col => col.header);

  // Filter rows based on visibleColumns
  const rows = filteredFiles.map(f =>
    columnMap
      .filter(col => visibleColumns[col.key])
      .map(col => f[col.field] || '')
  );

  if (rows.length === 0) {
    setSnackbar({ open: true, success: false, message: 'No data available to export.' });
    return;
  }

  autoTable(doc, { head: [headers], body: rows });
  doc.save('recents_export.pdf');
};


  useEffect(() => {
    let timer;
    if (snackbar.open) {
      timer = setTimeout(() => {
        setSnackbar({ ...snackbar, open: false });
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [snackbar.open]);

  const LoaderIcon = () => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 50 50"
      style={{ display: "block", margin: "0 auto" }}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        stroke="#ff6b35"
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
      >
        <animate
          attributeName="stroke-dasharray"
          values="1, 200;89, 200;89, 200"
          dur="1.5s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-dashoffset"
          values="0;-35;-124"
          dur="1.5s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );

 return (
  <div className="recents-page-container">
    <Sidebar />
    <div className="recents-page-content">
      <Breadcrumbs />
      <div style={{ 
        background: '#fff', 
        borderRadius: '8px', 
        padding: '24px 28px', 
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)', 
        borderLeft: '4px solid #ff6b35', 
        marginBottom: '24px' 
      }}>
        <h1 style={{ 
          fontSize: '24px', 
          fontWeight: 700, 
          color: '#212529', 
          margin: 0, 
          display: 'flex', 
          alignItems: 'center', 
          gap: '12px' 
        }}>
          <span style={{ 
            width: '28px', 
            height: '28px', 
            background: 'linear-gradient(135deg, #ff6b35 0%, #ff8c61 100%)', 
            borderRadius: '6px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            color: '#fff', 
            fontSize: '16px' 
          }}>
            📋
          </span>
          Your Recent Contracts
        </h1>
      </div>
      <Loader 
        isLoading={isLoading} 
        message="Gathering your latest picks-almost there" 
      />
      {!isLoading && (
        <>
        
          <div className="recents-header">
            <div className="recents-filters" style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'flex-end' }}>
              <div className="dropdown-wrapper" style={{ width: '200px' }}>
                <select
                  className="dropdown"
                  value={days}
                  onChange={(e) => setDays(e.target.value)}
                  aria-label="Filter by days"
                  style={{ width: '100%', border: '1px solid #ff6b35', borderRadius: '6px', outline:'none' }}
                >
                  <option value="2">Last 2 days</option>
                  <option value="5">Last 5 days</option>
                  <option value="7">Last 7 days</option>
                  <option value="14">Last 14 days</option>
                </select>
                <FaCaretDown className="dropdown-icon" />
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', margin: '8px 0' }}>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <button
  onClick={handleSwitchHierarchy}
  disabled={switchingHierarchy}
  style={{
    background: switchingHierarchy ? "#ccc" : "#ff6b35",
    color: "white",
    padding: "8px 14px",
    borderRadius: "6px",
    fontWeight: "bold",
    marginLeft: "10px",
    cursor: switchingHierarchy ? "not-allowed" : "pointer",
    border:'none',
  }}
>
  {switchingHierarchy ? "Switching..." : "Switch → " + (currentHierarchyMode === "default" ? "Client First" : "Year First")}
</button>
                <div style={{ position: 'relative', width: '170px' }}>
  <input
    type="text"
    placeholder="Search..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    style={{
      padding: '8px 30px 8px 8px',
      width: '100%',
      border: '1px solid #ff6b35',
      borderRadius: '4px',
    }}
    title="Search by contract name, client or status"
  />
  <FaSearch
    style={{
      position: 'absolute',
      right: '8px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#4A4A4A',
    }}
  />
</div>

                <button
                  onClick={() => setShowColumnOptions(true)}
                  style={{
                    cursor: 'pointer',
                    padding: '4px 12px',
                    borderRadius: '6px',
                    background: 'transparent',
                    color: '#4A4A4A',
                    border: '1px solid black',
                    fontSize: '16px',
                    fontWeight: 500,
                  }}
                title="Click to show/hide columns"
                >
                  ⚙ Column options
                </button>
                <div style={{ position: 'relative' }}>
                  <button
                    onClick={() => setShowDownloadMenu(!showDownloadMenu)}
                    style={{
                      cursor: 'pointer',
                      padding: '4px 12px',
                      borderRadius: '6px',
                      background: 'transparent',
                      border: '1px solid black',
                      color: '#4A4A4A',
                      fontSize: '16px',
                      fontWeight: 500,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  title="Click to export contracts as pdf or csv"
                  >
                    <img src={downloadIcon} alt="Download" style={{ width: '16px', height: '20px' }} /> Download
                  </button>
                  {showDownloadMenu && (
                    <div
                      className="Project-export-dropdown"
                      style={{ position: 'absolute', right: 0, marginTop: '6px', borderRadius: '6px' }}
                    >
                      <button
                        onClick={exportTableToCSV}
                        style={{
                          cursor: 'pointer',
                          border: 'none',
                          display: 'block',
                          padding: '8px 12px',
                          width: '120px',
                          textAlign: 'left',
                          background: 'none',
                          color: '#4A4A4A',
                        }}
                      >
                        Download CSV
                      </button>
                      <button
                        onClick={exportTablePDF}
                        style={{
                          cursor: 'pointer',
                          border: 'none',
                          display: 'block',
                          padding: '8px 12px',
                          width: '120px',
                          textAlign: 'left',
                          background: 'none',
                          color: '#4A4A4A',
                        }}
                      >
                        Download PDF
                      </button>
                    </div>
                  )}
                </div>
               
              </div>
            </div>
          </div>
         
          <div style={{ overflow: "auto" }}>
            <TreeTable
              value={filteredNodes}
              expandedKeys={expandedKeys}
              onToggle={(e) => setExpandedKeys(e.value)}
              tableStyle={{ width: "100%", tableLayout: "fixed" }}
              showGridlines
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 20, 50]}
            >
              {visibleColumns.name && (
              <Column
                field="name"
                header={<span title="Contracts">Contracts</span>}
                style={{ width: "25%", color: "black" }}
                body={(node) => {
                  const isFolder = node.data?.type === "Folder";
                  const isExpanded = !!expandedKeys[node.key];
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        paddingLeft: `${node.level * 30}px`,
                        color: "black",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {node.children && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setExpandedKeys((prev) => {
                              const newKeys = { ...prev };
                              if (newKeys[node.key]) {
                                delete newKeys[node.key];
                              } else {
                                newKeys[node.key] = true;
                              }
                              return newKeys;
                            });
                          }}
                          style={{
                            display: "inline-flex",
                            width: "18px",
                            height: "18px",
                            background: "white",
                            color: "#ff6b35",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            lineHeight: "18px",
                            verticalAlign: "middle",
                            fontSize: "18px",
                            marginLeft: "5px",
                          }}
                          title="Click to expand/collapse"
                        >
                          {isExpanded ? "−" : "+"}
                        </span>
                      )}
                {isFolder ? (
                        <span style={{ overflow: "hidden", textOverflow: "ellipsis" }} title={node.key?.startsWith('YEAR-') ? 'Year of contract' : node.data.name}>
                          📂 {node.data.name}
                        </span>
                      ) : (
                        <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                          📄{" "}
                          <a
                            href={node.data.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#1976d2", textDecoration: "none" }}
                          >
                            {node.data.name}
                          </a>
                        </span>
                      )}
                    </div>
                  );
                }}
              />
              )}
             {visibleColumns.clientName && (
              <Column
                field="clientName"
                header={<span title="Client">Client</span>}
                style={{ width: "15%", textAlign: "center", color: "black" }}
                body={(node) => {
                  if (node.key.split("-").length === 1) return null;
                  return (
                    <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {node.data.clientName}
                    </span>
                  );
                }}
              />
              )}
              {visibleColumns.status && (
              <Column
                field="status"
                header={<span title="Status">Status</span>}
                style={{ width: "15%", textAlign: "center", color: "black" }}
                body={(node) => {
                  if (node.key.split("-").length === 1 || node.data.type === "Folder") return null;
                  const status = node.data.status || "Trashed";
                  const statusColorMap = {
                     "Active": "#1976D2",           
                      "Approved": "#2E7D32",        
                      "Archived": "#9C27B0",         
                      "Draft": "#ec407a",            
                      "Expired": "#C62828",          
                      "Pending Approval": "#FBC02D", 
                      "Signed": "#009688",          
                      "Terminated": "#455A64",       
                      "Trashed": "#E64A19",          
                      "Moved to Trash": "#E64A19",   
                  };
                  const backgroundStyle = {
                    background: statusColorMap[status] || "#616161",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    color: status === "Pending Approval" ? "#333" : "#fff",
                    display: "inline-block",
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "normal", 
                    lineHeight: "1.2", 
                    maxHeight: "50px",
                  };
                  return <span style={backgroundStyle}>{status}</span>;
                }}
              />
              )}
              {visibleColumns.dateCreated && (
              <Column
                field="createdDate"
                header={<span title="Created Date">Created Date</span>}
                style={{ width: "15%", textAlign: "center", color: "black" }}
                body={(node) => {
                  if (node.key.split("-").length === 1) return null;
                  return (
                    <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {node.data.createdDate}
                    </span>
                  );
                }}
              />
              )}
              {visibleColumns.modified && (
              <Column
                field="modified"
                header={<span title="Modified">Modified</span>}
                style={{ width: "15%", textAlign: "center", color: "black" }}
                body={(node) => {
                  if (node.key.split("-").length === 1) return null;
                  return (
                    <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {node.data.modified}
                    </span>
                  );
                }}
              />
              )}
              {visibleColumns.actions && (
              <Column
                header="Actions"
                style={{ width: "15%", textAlign: "center", color: "black" }}
                body={(node) => {
                  if (node.data.type !== "File") return null;
                  return (
                    <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                      <Info
                        className="action-image1"
                        style={{
                          cursor: "pointer",
                          color: "#ff6b35",
                          width: "16px",
                          height: "16px",
                          marginTop: "6px",
                        }}
                        titleAccess="View Details"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          navigate('/categories', { state: { contractId: node.data.id } });
                        }}
                      />
                      <button
                        title="Add Favourite"
                        className="action-btn favorite-btn"
                        onClick={() => handleAddFavourite(node)}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill={node.data.is_favourite  ? "#ff6b35" : "none"}
                          stroke="#ff6b35"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polygon points="12 2 15 9 22 9 17 14 18 21 12 17 6 21 7 14 2 9 9 9 12 2" />
                        </svg>
                      </button>
                      <button
                        title="Trash"
                        className="action-btn trash-btn"
                        onClick={() => handleTrash(node)}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ff6b35"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                        </svg>
                      </button>
                    </div>
                  );
                }}
              />
              )}
            </TreeTable>
          </div>
          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
              <nav style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <button
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '18px',
                    border: '1px solid #ff6b35',
                    background: currentPage === 1 ? '#f3f4f6' : '#fff',
                    color: currentPage === 1 ? '#9ca3af' : '#ff6b35',
                    cursor: 'pointer',
                  }}
                >
                  {'<'}
                </button>
                {Array.from({ length: 3 }, (_, i) => {
                  const startPage = Math.max(1, currentPage - 1);
                  const page = startPage + i;
                  if (page <= totalPages) {
                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '18px',
                          border: '1px solid #ff6b35',
                          background: page === currentPage ? '#ff6b35' : '#fff',
                          color: page === currentPage ? '#fff' : '#ff6b35',
                          cursor: 'pointer',
                        }}
                      >
                        {page}
                      </button>
                    );
                  }
                  return null;
                })}
                <button
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '18px',
                    border: '1px solid #ff6b35',
                    background: currentPage === totalPages ? '#f3f4f6' : '#fff',
                    color: currentPage === totalPages ? '#9ca3af' : '#ff6b35',
                    cursor: 'pointer',
                  }}
                >
                  {'>'}
                </button>
              </nav>
            </div>
          )}
          {showColumnOptions && (
            <div
              style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.4)',
                backdropFilter: 'blur(6px)',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-end',
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  width: '340px',
                  background: '#fff',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  marginTop: '100px',
                  marginRight: '20px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px 12px',
                    background: '#ff6b35',
                    color: '#fff',
                    fontWeight: 700,
                  }}
                >
                  <div>Column Options</div>
                  <button
                    onClick={cancelColumnChanges}
                    aria-label="Close"
                    style={{ color: '#fff', background: 'transparent', border: 'none', fontSize: '25px', cursor: 'pointer' }}
                  >
                    ×
                  </button>
                </div>
                <div
                  style={{
                    marginTop: '-8px',
                    fontSize: '12px',
                    color: '#6B7280',
                    padding: '0 12px 8px',
                    borderBottom: '1px solid #e5e7eb',
                  }}
                >
                </div>
                <div style={{ maxHeight: '50vh', overflowY: 'auto', padding: '10px 12px' }}>
                 {['name', 'clientName', 'dateCreated', 'status', 'modified', 'actions'].map(
  (key) => (
    <div
      key={key}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 0',
        borderBottom: '1px solid #f3f4f6',
      }}
    >
      <span style={{ fontSize: '14px', color: '#111827' }}>
        {key === 'name' ? 'Contract Name' : key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
        {mandatoryColumns.includes(key) ? <span style={{ color: '#ff6b35' }}> *</span> : ''}
      </span>
      <button
        onClick={() => toggleColumn(key)}
        disabled={mandatoryColumns.includes(key)}
        aria-label={tempVisibleColumns[key] ? `Hide ${key}` : `Show ${key}`}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: mandatoryColumns.includes(key) ? 'not-allowed' : 'pointer',
          opacity: mandatoryColumns.includes(key) ? 0.6 : 1
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
          {!tempVisibleColumns[key] && (
            <line x1="2" y1="2" x2="18" y2="18" stroke="#000000" strokeWidth="3" />
          )}
        </svg>
      </button>
    </div>
  )
)}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px 12px', borderTop: '1px solid #e5e7eb' }}>
                  <button
                    onClick={cancelColumnChanges}
                    style={{ background: 'transparent', color: '#ff6b35', border: '1px solid #ff6b35', padding: '8px 14px', borderRadius: '6px' }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={applyColumnChanges}
                    style={{ background: '#ff6b35', color: '#fff', border: '1px solid #ff6b35', padding: '8px 14px', borderRadius: '6px' }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}
          {isDeleteModalOpen && (
          <DeleteConfirmationModal
  isOpen={isDeleteModalOpen}
  onClose={() => setIsDeleteModalOpen(false)}
  onConfirm={confirmDelete}
  contractName={contractToDelete?.data?.name || "Unnamed Document"}
  isDeleting={isDeleting}
/>
          )}

          {snackbar.open && (
            <div
              style={{
                position: "fixed",
                bottom: "20px",
                left: "20px",
                backgroundColor: snackbar.success ? "#4caf50" : "#ff6b35",
                color: "#fff",
                padding: "10px",
                borderRadius: "8px",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {snackbar.message}
              <button
                onClick={() => setSnackbar({ ...snackbar, open: false })}
                style={{ background: "transparent", border: "none", color: "#fff", cursor: "pointer", fontSize: '20px', marginTop: '5px' }}
              >
                ×
              </button>
            </div>
          )}
        </>
      )}
    </div>
  </div>
);
};

export default RecentsPage;